// tempexp_18086-start
import icon from 'img/icons/referral_flash_icon.png';
import React from 'react';
import { referralProgramBonusQuota } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { SubscriptionItem } from 'reactApp/ui/Mobile/SubscriptionsModal/SubscriptionList/Components/SubscriptionListItem/SubscriptionListItem';
import { useRefferalModalHandlers } from 'reactApp/ui/ReferralProgram/ReferralModal/hooks/useRefferalModalHandlers';

export const ReferralSubscriptionItem = ({ isRebrandingQuotaLanding = false }: { isRebrandingQuotaLanding?: boolean }) => {
    const { referralQuota, showModal } = useRefferalModalHandlers();
    const title = referralQuota.original ? referralQuota.value : 'Бонусы за друзей';
    const description = referralQuota.original ? 'Активные бонусы за друзей' : `+${referralProgramBonusQuota.value} за каждого друга`;

    return (
        <SubscriptionItem
            type="referral"
            icon={icon}
            title={title}
            description={description}
            onClick={showModal}
            isRebranding
            isRebrandingQuotaLanding={isRebrandingQuotaLanding}
        />
    );
};
// tempexp_18086-end
